export class OverlaySubscribe {
  constructor(el) {
    this.el = el;
    this.overlay = document.querySelector("[data-overlay-subscribe]");
    this.quizName = document.querySelector("[data-subscribe-quiz-name]");
    this.quizAllowedTime = document.querySelector(".js-overlay-time");
    this.yesButton = this.overlay.querySelector('[data-action="yes"]');

    this.onClick = this.onClick.bind(this);
    this.onClickDispatch = this.onClickDispatch.bind(this);

    this.el.addEventListener("click", this.onClick);
  }

  onClick(e) {
    this.open();

    e.preventDefault();
  }

  open() {
    document.documentElement.classList.add("overlay-subscribe-is-active");
    this.quizName.innerText =
      this.el.querySelector("[data-quiz-name]").innerText;
    this.quizAllowedTime.value = parseInt(this.el.dataset.allowedTime, 10);

    this.overlay.addEventListener("click", this.onClickDispatch);
  }

  onClickDispatch(e) {
    var target = e.target;

    if (target.dataset.action == "yes") {
      let href = this.el.href;
      if (this.quizAllowedTime.value) {
        href = `${this.el.href}&t=${this.quizAllowedTime.value}`;
      }
      window.location.href = href;
    } else if (target.dataset.action == "no") {
      this.close();
    }
  }

  close() {
    this.overlay.removeEventListener("click", this.onClickDispatch);
    document.documentElement.classList.remove("overlay-subscribe-is-active");
  }
}
